import { MainPaceTask } from 'providence-types';

export namespace PaceTasksToObjectMapper {
  export interface Options {
    task: MainPaceTask;
    fieldKey: string;
  }
}
